<template>
   <v-app >

    <v-navigation-drawer 
    app 
    v-model="drawer" 
    > 
   
   <v-list  >
      <v-subheader>REPORTS</v-subheader>
      <v-list-item-group   color="primary">
        <v-list-item
          
         v-for="link of links"
         :key="link.title"
         :to="link.url"
        >
          <v-list-item-icon>
            <v-icon   > {{link.icon}} </v-icon>
           </v-list-item-icon>
          <v-list-item-content   >
            <v-list-item-title  v-text="link.title" > </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
         <v-list-item
         @click="onLogout" 
         v-if="isUserLoggedIn"
         >
         <v-icon left>mdi-motorbike</v-icon>
         <v-list-item-title  v-text="'Logout'"  >  </v-list-item-title>
         </v-list-item>
          
      </v-list-item-group>
    </v-list>

  </v-navigation-drawer>
      
<v-toolbar
     color="primary"
      dark
    >
      <v-app-bar-nav-icon
       @click="drawer=!drawer"
       class='hidden-md-and-up'
       ></v-app-bar-nav-icon> <!--по клику по кнопке присваиваем дроверу противоположное значение-->

      <v-toolbar-title>
        <router-link to="/" tag="span" class="pointer"> Ad application </router-link>
    <!--директива роутер для добавления пути до приложения, спан чтобы красиво все смотрелось-->

    </v-toolbar-title>

      <v-spacer></v-spacer>
         <v-toolbar-items class="hidden-sm-and-down"> <!--класс для адаптации смол меньше чем 960 пк-->
        <v-btn  
          v-for="link in links"
          :key="link.title"
          :to="link.url"

        >
          <v-icon left>{{link.icon}}</v-icon>
           {{link.title}}
         </v-btn>
          
          <v-btn  
          @click="onLogout"
          v-if="isUserLoggedIn"     
          >
           <v-icon left>mdi-motorbike</v-icon>
           Logout
         </v-btn>

   
        </v-toolbar-items>
      <v-btn icon>
        <v-icon>mdi-export</v-icon>
      </v-btn>

    </v-toolbar>


    <v-content>
      <router-view></router-view>
       
    </v-content>
    <template v-if="error"> 
     <v-snackbar
      :color="error"
      :multi-line="true"
      :timeout="5000"
      @input="closeError"
      :value="true"
      >
     {{error}}
      <v-btn
        dark
       @click.native="closeError"
      >
        Close
      </v-btn>
    </v-snackbar>
    </template>
  </v-app>
</template>

<script>
//  <v-list-item-group v-model="item" color="primary">
export default {
  data () {
    return{
      drawer: false, //возврат поля дровер в значении фолс
       //массив ссылок для бокового меню был здесь
        

    }
  },
  computed: {
    error () {
      return this.$store.getters.error
    },
    isUserLoggedIn () {
      return this.$store.getters.isUserLoggedIn
    },
    links () {
      if (this.isUserLoggedIn) {
        return[
         {title: 'Orders', icon: 'mdi-face', url: '/orders'},
        {title: 'New ad', icon: 'mdi-face', url: '/new'},
        {title: 'My ads', icon: 'mdi-face', url: '/list'}

        ]
      }
       return[
        {title: 'Login', icon: 'mdi-lock', url: '/login'},
        {title: 'Registration', icon: 'mdi-face', url: '/registration'}

        ]
    }
  },
  methods: {
    closeError () {
      this.$store.dispatch('clearError') //очищает ошибку, она больше не будет показываться
    },
    onLogout () {
      this.$store.dispatch('logoutUser') 
      this.$router.push('/')
    }

  }
  
} 
</script>
<!-- 
  <v-toolbar-items class="hidden-sm-and-down"> -->

    <style scoped>
    .pointer{
        cursor: pointer;
    }
   

.group {
  display: flex;
  flex: 1;
  justify-content: space-around;
}
</style>
       
